export default __webpack_public_path__ + "static/earth-night-nasa-unsplash-hero-1098117e4270bb86fffe85698c3e86d9.jpeg";